import SearchIcon from "@mui/icons-material/Search";
import {
  FormControl,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { DateTime } from "luxon";
import { useState } from "react";
import { Form } from "react-router-dom";

const AccountsFilter = ({ filters, onFilterChange }) => {
  const [month, setMonth] = useState(false);

  const getDropdownName = (value) => {
    const estDate = DateTime.now()
      .setZone("America/New_York")
      .minus({ months: 1 + value });

    return estDate.toFormat("MMMM yyyy"); // Example: "April 2025"
  };

  const changeMonth = (value) => {
    onFilterChange({ previous_month: value });
    setMonth(value);
  };

  return (
    <Form role={"searchform"}>
      <Grid container spacing={4} sx={{ pt: 4 }} alignItems="center">
        <Grid item xs={8} sx={{ justifyContent: "space-between" }}>
          <FormControl variant="standard" fullWidth>
            <Input
              name="searchTerm"
              value={filters.searchTerm ?? ""}
              onChange={(e) => {
                onFilterChange({ searchTerm: e.target.value });
              }}
              form="search"
              type="search"
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={3} sx={{ display: "flex", justifyContent: "flex-end" }}>
          <FormControl margin="normal" size="small">
            <InputLabel>Month*</InputLabel>
            <Select
              value={month}
              onChange={(e) => changeMonth(e.target.value)}
              label="Month*"
              sx={{ width: "180px" }}
            >
              <MenuItem value={false}>{getDropdownName(0)}</MenuItem>
              <MenuItem value={true}>{getDropdownName(1)}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AccountsFilter;
